import React, { useEffect, useState } from 'react';
import styles from './CreateStorageModal.module.css';
import { API_URL } from '../../../config/api';

const EMPTY_FORM = {
  region_id: null,
  name: '',
  address: '',
  rounding_type: 'no_rounding',
  fiscalization_type: 'disabled',
  is_sales_mode_enabled: false,
};

const CreateStorageModal = ({ isOpen, onClose, onCreated, storage }) => {
  const isEdit = Boolean(storage);
  const token = localStorage.getItem('token');

  const [formData, setFormData] = useState(EMPTY_FORM);

  // ====== ЗАПОЛНЕНИЕ / СБРОС ФОРМЫ ======
  useEffect(() => {
    if (!isOpen) {
      // 🔹 модалка закрылась → очистка
      setFormData(EMPTY_FORM);
      return;
    }

    if (storage) {
      // 🔹 режим редактирования
      setFormData({
        region_id: storage.region_id ?? null,
        name: storage.name ?? '',
        address: storage.address ?? '',
        rounding_type: storage.rounding_type ?? 'no_rounding',
        fiscalization_type: storage.fiscalization_type ?? 'disabled',
        is_sales_mode_enabled: storage.is_sales_mode_enabled ?? false,
      });
    } else {
      // 🔹 режим создания
      setFormData(EMPTY_FORM);
    }
  }, [storage, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({
      ...p,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // ====== SUBMIT ======
  const handleSubmit = async (e) => {
    e.preventDefault();

    const url = isEdit
      ? `${API_URL}/api/storages/${storage.id}`
      : `${API_URL}/api/storages`;

    const method = isEdit ? 'PUT' : 'POST';

    console.log(`📤 ${method}`, formData);

    try {
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      await res.json();

      if (!res.ok) {
        alert(`Ошибка: ${res.status}`);
        return;
      }

      onCreated();
      onClose(); // ⬅ тут форма уже очистится useEffect-ом
    } catch (err) {
      alert('Ошибка сохранения');
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>
          {isEdit ? 'Редактирование склада' : 'Создание склада'}
        </h2>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Название *</label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Адрес *</label>
            <input
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.buttonGroup}>
            <button type="submit" className={styles.createBtn}>
              {isEdit ? 'Сохранить' : 'Создать'}
            </button>
            <button
              type="button"
              className={styles.cancelBtn}
              onClick={onClose}
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateStorageModal;
